// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';
import {
  
  QueryClient,
  QueryClientProvider
} from '/home/runner/work/rgs-back-office/rgs-back-office/webapp/node_modules/@tanstack/react-query';

const reactQueryConfig = {};
const client = new QueryClient(reactQueryConfig.queryClient || {});
export function rootContainer(container) {
  return (
    <QueryClientProvider
      client={client}
      
    >
      {container}
      
    </QueryClientProvider>
  );
}
